<template>

    <main>

        <header-bar></header-bar>

        <section class="lp container">

            <block class="block-1">
                <div slot="block-left">
                    <div class="block--first__text">
                        <h1>Peníze ihned.<br> Bez starostí.<br>Kompletní servis.</h1>
                        <p>Máte restituční nároky? Nabízíme jejich odkup, okamžité finanční vyplacení a kompletní servis v rámci smluvní dohody.</p>
                        <router-link to="kontakt" class="btn--primary">Prodám nároky</router-link>
                    </div>
                </div>

                <div slot="block-right">
                    <div class="block-land">
                        <div class="block-bubble">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
            </block>




            <block class="block-2" style="display: none">
                <div slot="block-left">
                    <div class="block--first__text">
                        <h1>Co znamená<br> restituční tečka?</h1>
                        <p>V červenci 2018 nastane tzv. restituční tečka, která byla schválená v roce 2016. To znamená, že původní majitelé, kterým byl v minulosti protiprávně státem odebrán soukromý majetek, po vypršení této lhůty <span class="under">ztrácí možnost nárokovat</span> po státu náhradu formou převodu náhradního pozemků.</p>
                    </div>
                </div>

                <div slot="block-right" class="block-clock">
                    <div class="block-clock__content">
                        <h3><span>zbývá</span> <b>{{finalDate}}</b> <span>dní</span></h3>
                    </div>
                </div>
            </block>


            <block class="block-3">
                <div slot="block-left" class="block-content">
                    <div class="block-box">
                        <h3>A jak to celé probíhá?</h3>
                        <ul>
                            <li>Kontaktujte nás</li>
                            <li>Smluvní dohoda</li>
                            <li>Oznámení pro Státní pozemkový úřad</li>
                            <li>Vyplacení kupní ceny</li>
                        </ul>
                        <router-link to="kontakt" class="btn--primary">Prodám nároky</router-link>
                    </div>
                </div>
            </block>
        </section>

        <router-view></router-view>


        <footer>
            <p>2019</p>
        </footer>
    </main>

</template>

<script>
import HeaderBar from "./HeaderBar";
import Block from "./Block";
import Popup from "./Popup";

export default {
  name: "Home",
  components: {
    "header-bar": HeaderBar,
    block: Block,
    popup: Popup
  },
  data() {
      return {
          finalDate: new Number()
      }
  },
  created() {
    const oneDay = 1000 * 60 * 60 * 24
    const today = new Date()
    const finalDay = new Date(2018, 6, 22)
    const difference = Math.abs(finalDay - today)
    const end = Math.round(difference / oneDay) - 30
    this.finalDate = end
  }
};
</script>


<style lang="stylus">
@import '../style/config';

footer {
    height: 100px;
    text-align: center;
    color: #dcdcdc;
}

.btn--primary {
    display: inline-block;
    padding: 1em 3em;
    border-radius: 4px;
    color: #1b85e8;
    font-weight: bold;
    transition: all 250ms;
    cursor: pointer;
    background-color: $blue-dodge;
    color: $white;
    text-decoration: none

    &:hover {
        background-color: $blue-dodge - 20;
    }

    &:active {
        background-color: $blue-dodge - 40;
    }
}

.btn--link {
    font-weight: bold;

    &::after {
        content: '>>';
        margin-left: 0.4em;
        letter-spacing: 0.1em;
    }
}

.show-enter-active, .show-leave-active
    transition: opacity 250ms

.show-enter, .show-leave-to
    opacity: 0

.under
    text-decoration: underline
</style>



// WEBPACK FOOTER //
// src/components/Home.vue